const values = [
  {
    number: "01.",
    title: "Enfoque En El Cliente",
    description:
      "Ponemos al cliente en el centro de cada proyecto, buscando su total satisfacción con compromiso, excelencia y soluciones personalizadas.",
  },
  {
    number: "02.",
    title: "Cumplimiento Normativo",
    description:
      "Actuamos bajo estrictos estándares legales, técnicos y de calidad, cumpliendo todas las normativas, certificaciones y requisitos que rigen nuestra actividad.",
  },
  {
    number: "03.",
    title: "Mejora Continua E Innovación",
    description:
      "Evolucionamos constantemente, incorporando nuevas tecnologías, prácticas seguras y procesos eficientes que optimizan cada obra.",
  },
  {
    number: "04.",
    title: "Compromiso Ambiental",
    description:
      "Promovemos prácticas responsables que reduzcan el impacto ambiental, priorizando el uso consciente de recursos y tecnologías sostenibles.",
  },
  {
    number: "05.",
    title: "Seguridad E Higiene Laboral",
    description:
      "Garantizamos entornos de trabajo seguros y saludables mediante políticas preventivas que cuidan a nuestro equipo humano.",
  },
  {
    number: "06.",
    title: "Capacitación Permanente",
    description:
      "Impulsamos la formación continua de nuestro personal como base de nuestra excelencia operativa.",
  },
];

export default function QualityValues() {
  return (
    <section className="bg-white py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 uppercase tracking-tight">
            Políticas de Calidad
          </h2>
        </div>

        {/* Layout: 3 left - image center - 3 right */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 items-center">
          {/* Left column - 1, 2, 3 */}
          <div className="space-y-10">
            {values.slice(0, 3).map((value) => (
              <div key={value.number} className="text-center">
                <p className="text-amber-600 text-4xl font-black leading-none mb-1">
                  {value.number}
                </p>
                <h3 className="text-slate-900 font-bold text-lg mb-2">
                  {value.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>

          {/* Center image */}
          <div className="flex justify-center">
            <div className="rounded-2xl overflow-hidden">
              <img
                src="https://ilkpzxkwhjwvollmxurg.supabase.co/storage/v1/object/public/proyectos/SERVICES.jpeg"
                alt="Políticas de calidad"
                className="w-full h-[500px] object-cover rounded-2xl"
              />
            </div>
          </div>

          {/* Right column - 4, 5, 6 */}
          <div className="space-y-10">
            {values.slice(3, 6).map((value) => (
              <div key={value.number} className="text-center">
                <p className="text-amber-600 text-4xl font-black leading-none mb-1">
                  {value.number}
                </p>
                <h3 className="text-slate-900 font-bold text-lg mb-2">
                  {value.title}
                </h3>
                <p className="text-slate-500 text-sm leading-relaxed">
                  {value.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
